import { render, staticRenderFns } from "./template-plan-item.vue?vue&type=template&id=3a0a50d0&scoped=true&"
import script from "./template-plan-item.vue?vue&type=script&lang=js&"
export * from "./template-plan-item.vue?vue&type=script&lang=js&"
import style0 from "./template-plan-item.vue?vue&type=style&index=0&id=3a0a50d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a50d0",
  null
  
)

export default component.exports